import {
  isFilesCellBeingCopied,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/FilePropertyTypeStrategy/functions/isFilesCellBeingCopied'
import {RestrictedEditReasonType} from '@toolify/client/src/modules/databases/enum/RestrictedEditReasonType'

export function useFilesPropertyTypeStrategy() {

  const getIsActive = (value: unknown) => {
    return !isFilesCellBeingCopied(value)
  }

  const getRestrictedEditReason = (value?: unknown): RestrictedEditReasonType => {
    return isFilesCellBeingCopied(value) ? RestrictedEditReasonType.FilesBeingCopied : RestrictedEditReasonType.ReadOnly
  }

  return {
    getIsActive,
    getRestrictedEditReason,
  }
}
